<template>
  <a
    v-if="props.href.startsWith('http')"
    :href="props.href"
    :target="props.target"
    rel="noopener noreferrer"
  >
    <slot></slot>
  </a>
  <NuxtLinkLocale v-else :href="props.href" :target="props.target">
    <slot />
  </NuxtLinkLocale>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  href: {
    type: String,
    default: ''
  },
  target: {
    type: String as PropType<
      '_blank' | '_parent' | '_self' | '_top' | (string & object) | null | undefined
    >,
    default: undefined,
    required: false
  }
})
</script>
